export default "__VITE_ASSET__LBUlyxX5__";